import React, { useState } from 'react';

import './inputRows.scss';

import { qualities } from '../../../../Constants';

export default ({ lang, link, select, addBim, add, language }) => {
    const [uri, setUri] = useState('');
    const [quality, setQuality] = useState('hq');

    return (
        <div className='row'>
            <form onSubmit={e => {
                e.preventDefault();
                addBim({
                    uri,
                    lang,
                    quality,
                })
            }}>

                <h2>{language}</h2>
                <label>{link}
                    <div>
                        <input
                            required
                            type="url"
                            placeholder={link}
                            onChange={e => setUri(e.target.value.trim())}
                        />
                    </div>
                </label>
                <div className="selectTag">
                    <label>{select}</label>
                    <select onChange={event => setQuality(event.target.value)}>
                        {qualities.map(quality => (
                            <option value={quality} selected={quality === 'hq'}>{quality}</option>
                        ))}
                    </select>

                </div>
                <button>{add}</button>

            </form>
        </div>
    );
};
